import React, { useEffect, useState } from "react";
import { FaTrash, FaEdit, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import "../Control-panel.css"; // Asegúrate de tener este archivo CSS para los estilos

const ControlSalesExpress = () => {
  const [messageModal, setMessageModal] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [listSalesExpress, setListSalesExpress] = useState([]);

  const [toggleFormSalesExpress, setToggleFormSalesExpress] = useState(false);

  const [typeSale, setTypeSale] = useState("");
  const [precioSale, setPrecioSale] = useState(0);
  const [precioKilo, setPrecioKilo] = useState(0);

  const [editingSalesExpress, setEditingSalesExpress] = useState(null);
  const [updatedData, setUpdatedData] = useState({});
  const [isUpdating, setIsUpdating] = useState(false);

  const [emptyData, setEmptyData] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL;

  const typeMessages = {
    create: "¡Tipo de venta express registrado exitosamente!",
    update: "¡Datos de venta express actualizados exitosamente!",
    delete: "Tipo de venta express eliminado exitosamente!",
    error: "Error en el mensaje del modal",
  };

  useEffect(() => {
    getSalesExpress();
  }, []);

  const openModalSuccess = (type) => {
    switch (type) {
      case "create":
        setMessageModal(typeMessages.create);
        break;
      case "update":
        setMessageModal(typeMessages.update);
        break;
      case "delete":
        setMessageModal(typeMessages.delete);
        break;
      default:
        setMessageModal(typeMessages.error);
        break;
    }
    setIsModalOpen(true);
    setTimeout(() => {
      setIsModalOpen(false);
    }, 3000);
  };

  const cleanFormSalesExpress = () => {
    setTypeSale("");
    setPrecioSale(0);
    setPrecioKilo(0);
  };

  const addSaleExpress = () => {
    const data = { typeSale, precioSale, precioKilo };

    if (!typeSale || !precioSale || !precioKilo) {
      setEmptyData(true);
      setTimeout(() => {
        setEmptyData(false);
      }, 3000);
      return;
    }

    fetch(`${API_URL}/create-sale-express`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.result) {
          openModalSuccess("create");
          getSalesExpress();
          setToggleFormSalesExpress(false);
          cleanFormSalesExpress();
        } else {
          alert("No se pudo registrar el nuevo tipo de venta express");
        }
      })
      .catch(() => {
        console.log("ERROR CACTH");
      });
  };

  const getSalesExpress = () => {
    fetch(`${API_URL}/sales-express`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.result) {
          setListSalesExpress(result.result);
        } else {
          console.log("No se pudo consultar los tipos de ventas express");
        }
      });
  };

  const updateSaleExpress = () => {
    if (!isUpdating) return;

    const formattedData = {
      ...updatedData,
    };

    fetch(`${API_URL}/update-sale-express/${editingSalesExpress}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formattedData),
    })
      .then((response) => response.json())
      .then(() => {
        openModalSuccess("update");
        getSalesExpress();
        setEditingSalesExpress(null);
        setIsUpdating(false);
      })
      .catch((error) =>
        console.error("Error al actualizar el tipo de venta express:", error)
      );
  };

  const deleteSaleExpress = (typeSaleExpress) => {
    fetch(`${API_URL}/sale-express-delete/${typeSaleExpress}`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.message) {
          openModalSuccess("delete");
          setListSalesExpress(
            listSalesExpress.filter(
              (saleExpress) => saleExpress.type_sale !== typeSaleExpress
            )
          ); // Elimina visualmente el plan
        } else {
          alert("Error al eliminar el tipo de venta express.");
        }
      })
      .catch((error) =>
        console.error("Error al eliminar el tipo de venta express:", error)
      );
  };

  const enableEditing = (saleExpress) => {
    setEditingSalesExpress(saleExpress.type_sale);
    setUpdatedData({
      newTypeSale: saleExpress.type_sale,
      precio_sale_express: saleExpress.precio_sale_express,
      precio_kilo: saleExpress.precio_kilo,
    });
    setIsUpdating(true);
  };

  const handleInputChange = (e, field) => {
    const value = e.target.value;

    setUpdatedData((prev) => {
      const newData = {
        ...prev,
        [field]: value,
      };

      const allFieldsFilled = Object.values(newData).every(
        (val) => String(val || "").trim() !== ""
      );
      setIsUpdating(allFieldsFilled);

      return newData;
    });
  };

  return (
    <div className="container-control-module">
      <div className="table-container">
        <h2>Consulta de tipo de ventas express</h2>
        <table>
          <thead>
            <tr>
              <th>Tipo de venta express</th>
              <th>Precio venta express</th>
              <th>Precio por kilo</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {listSalesExpress.map((saleExpress) => {
              return (
                <tr key={saleExpress.type_sale}>
                  <td>
                    {editingSalesExpress === saleExpress.type_sale ? (
                      <input
                        type="text"
                        value={updatedData.newTypeSale}
                        onChange={(e) => handleInputChange(e, "newTypeSale")}
                      />
                    ) : (
                      saleExpress.type_sale
                    )}
                  </td>
                  <td>
                    {editingSalesExpress === saleExpress.type_sale ? (
                      <input
                        type="number"
                        value={updatedData.precio_sale_express}
                        onChange={(e) =>
                          handleInputChange(e, "precio_sale_express")
                        }
                      />
                    ) : (
                      saleExpress.precio_sale_express
                    )}
                  </td>
                  <td>
                    {editingSalesExpress === saleExpress.type_sale ? (
                      <input
                        type="number"
                        value={updatedData.precio_kilo}
                        onChange={(e) => handleInputChange(e, "precio_kilo")}
                      />
                    ) : (
                      saleExpress.precio_kilo
                    )}
                  </td>
                  <td>
                    <FaEdit
                      className="edit-icon"
                      onClick={() => enableEditing(saleExpress)}
                    />
                    <FaTrash
                      className="delete-icon"
                      onClick={() => deleteSaleExpress(saleExpress.type_sale)}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Formulario */}
      <div className="container-buttons-table">
        <button
          className="btn-add-control-panel"
          onClick={() => setToggleFormSalesExpress(true)}
        >
          + Registrar nuevo tipo de venta express
        </button>
        {isUpdating && (
          <button
            className="btn-add-control-panel"
            onClick={updateSaleExpress}
            disabled={!isUpdating}
          >
            Actualizar
          </button>
        )}
      </div>
      {toggleFormSalesExpress && (
        <div className="form-container mb-5">
          <h2>Gestión de tipos de ventas express</h2>
          <div className="form-group">
            <label htmlFor="type_sale_express">Tipo de venta express*</label>
            <input
              type="text"
              id="type_sale_express"
              value={typeSale}
              placeholder="Escribe el tipo de venta express"
              onChange={(e) => {
                setTypeSale(e.target.value);
              }}
            />
          </div>
          <div className="form-group">
            <label htmlFor="price-sale-express">Precio de venta express*</label>
            <input
              type="number"
              id="price-sale-express"
              value={precioSale}
              placeholder="Escribe el precio de la venta express"
              onChange={(e) => {
                setPrecioSale(e.target.value);
              }}
            />
          </div>
          <div className="form-group">
            <label htmlFor="price-kilo">Precio por kilo*</label>
            <input
              type="number"
              id="price-kilo"
              value={precioKilo}
              placeholder="Escribe el precio por kilo"
              onChange={(e) => {
                setPrecioKilo(e.target.value);
              }}
            />
          </div>
          <div className="add-container">
            <button
              className="btn-add-control-panel mb-4"
              onClick={() => addSaleExpress()}
            >
              Crear venta express
            </button>
          </div>
        </div>
      )}
      {/* Modal de éxito */}
      {isModalOpen && (
        <div className="modal-success">
          <div className="modal-content">
            <FaCheckCircle size={100} color="green" className="modal-icon" />
            <h1>{messageModal}</h1>
          </div>
        </div>
      )}
      {emptyData && (
        <div className="modal-success">
          <div className="modal-content">
            <FaTimesCircle size={100} color="red" className="modal-icon" />
            <h1>Por favor llenar todos los campos obligatorios(*)</h1>
          </div>
        </div>
      )}
    </div>
  );
};

export default ControlSalesExpress;
